import { render, staticRenderFns } from "./GridDeDemonstracoes.vue?vue&type=template&id=3a79d832&scoped=true&"
import script from "./GridDeDemonstracoes.vue?vue&type=script&lang=ts&"
export * from "./GridDeDemonstracoes.vue?vue&type=script&lang=ts&"
import style0 from "./GridDeDemonstracoes.vue?vue&type=style&index=0&id=3a79d832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a79d832",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
